import { useMemo } from 'react';
import type { ResolveThunks } from 'react-redux';
import { useDispatch } from 'react-redux';
import type { ActionCreatorsMapObject } from 'redux';
import { bindActionCreators } from 'redux';
import type { ThunkDispatch } from 'types/redux';

/**
 * Hook to mimic the `mapDispatchToProps` callback of react-redux `connect()` with `useDispatch`.
 * @param actionCreators IMPORTANT: This should never change, as the hook won't be re-evaluated.
 */
export const useWithDispatch = <T extends ActionCreatorsMapObject<any>>(actionCreators: T) => {
  const dispatch = useDispatch<ThunkDispatch>();
  return useMemo(
    () => bindActionCreators(actionCreators, dispatch) as ResolveThunks<T>,
    // biome-ignore lint/correctness/useExhaustiveDependencies: intentional
    [dispatch]
  );
};
